import { createAuthClient } from "better-auth/react";

const LOCAL_HOSTS = ["localhost", "mac-mini"];

const getApiUrl = () => {
  if (typeof window === "undefined") return "";
  if (LOCAL_HOSTS.includes(window.location.hostname)) return ""; // proxy via Vite
  return "https://api.pracownik.ai";
};

export const authClient = createAuthClient({
  baseURL: getApiUrl(),
});

export const { signIn, signUp, signOut, useSession, sendVerificationEmail } = authClient;
